import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Offcanvas, Form, Navbar, Nav } from "react-bootstrap";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import { ImCross } from "react-icons/im";
import StaticLogo from "../assets/images/staticlogo.png";
import TelegramIcon from "../assets/svg/TelegramIcon";
import WhatsappIcon from "../assets/svg/WhatsappIcon";
import EyeIcon from "../assets/svg/EyeIcon";
import logo from "../assets/images/logo.png";
import BotHeadIcon1 from "../assets/images/icons/BotHeadIcon1.png";
import BotHeadIcon2 from "../assets/images/icons/BotHeadIcon2.png";
import BotHeadIcon5 from "../assets/images/icons/BotHeadIcon5.png";
import BotHeadIcon7 from "../assets/images/icons/BotHeadIcon7.png";
import WhatsappIcon1 from "../assets/images/social.png";
import Casino1 from "../assets/images/games-icon/casinoezugi-icon.webp";
import Evolution from "../assets/images/games-icon/Ezugi.webp";
import Exchange from "../assets/images/games-icon/Exchange.png";
import SportsbookIcon from "../assets/images/games-icon/Sportsbook.png";
import AuraGame from "../assets/images/games-icon/Turbo-games.png";
import Slots1 from "../assets/images/games-icon/slot-machine.png";
import supern from "../assets/images/games-icon/Supernova1.webp";
import APK from "../assets/images/android.png";
import xpg from "../assets/images/games-icon/xpg1.webp";
import kingmaker from "../assets/images/games-icon/Kingmaker.png";
import Pragmaticplay from "../assets/images/games-icon/casinoezugi-icon.webp";
import Qtech from "../assets/images/games-icon/Qtech.webp";
import SpribeIcon from "../assets/images/games-icon/Aviatornew.webp";
import { APK_LS_KEY, APP_CONST } from "../config/const";
import LanguageChange from "../views/components/LanguageChange";
import Calling1 from "../assets/images/phone-call.png";
import AltGame from "../assets/images/games-icon/ALTGaming.png";
import ModalWrapper from "./ModalWrapper";

const Header = () => {
  const [show, setShow] = useState(false);
  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState("login");
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [isLanguageShow, setIsLanguageShow] = useState(true);
  const [showNotifications, setShowNotifications] = useState(true);
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  const isApkEnv = localStorage.getItem(APK_LS_KEY) === "true";
  const handleModalShow = (modalName) => {
    setShowAuthModals(true);
    setDefaultModal(modalName);
  };
  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };
  useEffect(() => {
    loadNotifications();
  }, []);

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }}>{notf?.content}</label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}
      <header className="header beforeheader">
        <div className="top_head">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="logo">
                      <a href="/">
                        <img src={appDetails?.LOGO_URL} alt="Logo" />
                        {/* <img src={logo} alt="Logo" /> */}
                      </a>
                    </div>
                  </div>
                  <div className="staticLogo">
                    <img src={StaticLogo} />
                  </div>
                  <div className="middle-part">
                    <Navbar expand="lg">
                      <Container>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                          <Nav className="me-auto">
                            {/* <Nav.Link href="/sign-in">
                              <img src={Casino1} alt="bottom head link icon" />
                              <span>Ezugi</span>
                            </Nav.Link> */}
                            {/* <Nav.Link href="/sign-in">
                              <img
                                src={Evolution}
                                alt="bottom head link icon"
                              />
                              <span>Evolution</span>
                            </Nav.Link> */}
                            <Nav.Link href="/exchange/Cricket">
                              <img
                                src={Exchange}
                                alt="Exchange Icon"
                                width={20}
                              />
                              Exchange
                            </Nav.Link>
                            {/* <Nav.Link href="/spmsports/live">
                              <img src={SportsbookIcon} alt="Sportsbook" />
                              SPM Sports
                            </Nav.Link> */}
                            <Nav.Link href="/sportsbook">
                              <img src={SportsbookIcon} alt="Sportsbook" />
                              <span>Atlas</span>
                            </Nav.Link>
                            <Nav.Link href="/sign-in">
                              <img src={Slots1} alt="bottom head link icon" />
                              <span>Slots</span>
                            </Nav.Link>
                            {/* <Nav.Link href="/casino/supernowa">
                              <img src={supern} alt="bottom head link icon" />
                              <span>Supernowa</span>
                            </Nav.Link>
                            <Nav.Link href="/casino/xpg">
                              <img src={xpg} alt="bottom head link icon" />
                              <span>Xpg</span>
                            </Nav.Link> */}
                            <Nav.Link href="/kingmaker">
                              <img
                                src={kingmaker}
                                alt="bottom head link icon"
                              />
                              <span>Kingmaker</span>
                            </Nav.Link>

                            {/* <Nav.Link href="/casino/qtech">
                              <img src={Qtech} alt="bottom head link icon" />
                              <span>Qtech</span>
                            </Nav.Link>*/}
                            <Nav.Link href="/gap">
                              <img src={AltGame} alt="bottom head link icon" />
                              <span>Alt Gaming</span>
                            </Nav.Link>
                            <Nav.Link href="/vimplay">
                              <img src={AltGame} alt="bottom head link icon" />
                              <span>Vimplay Games</span>
                            </Nav.Link>
                            <Nav.Link href="/aura-games">
                              <img src={AuraGame} alt="bottom head link icon" />
                              <span>Aura Games</span>
                            </Nav.Link>
                            {/* <Nav.Link href="/sign-in">
                            <img src={SpribeIcon} alt="bottom head link icon" />
                            <span>Spribe</span>
                          </Nav.Link> */}
                          </Nav>
                        </Navbar.Collapse>
                      </Container>
                    </Navbar>
                  </div>
                  <div className="headerRight">
                    {/* <ul className="social">
                    <li>
                      <a target={"_blank"} href={`${appDetails?.TELEGRAM}`}>
                        <TelegramIcon />
                      </a>
                    </li>
                    <li>
                      <div
                        onClick={() =>
                          window.open(`https://wa.me/+917888846060`, "_blank")
                        }
                      >
                        <WhatsappIcon />
                      </div>
                    </li>
                  </ul> */}
                    <ul>
                      <li>
                        <div className="LanguageCancelSection d-none d-md-block">
                          <div className={isLanguageShow ? "" : "d-none"}>
                            <LanguageChange />
                          </div>
                          {isLanguageShow && (
                            <div
                              style={{ marginRight: "5px", cursor: "pointer" }}
                              onClick={() => setIsLanguageShow((prev) => !prev)}
                              className="LanguageCancel"
                            >
                              <ImCross />
                            </div>
                          )}
                        </div>
                      </li>
                    </ul>
                    <a
                      href={`tel://${appDetails?.PHONE}`}
                      className="d-block d-md-none"
                    >
                      <img
                        src={Calling1}
                        alt="Calling icon"
                        style={{ width: "38px" }}
                      />
                    </a>
                    <a
                      className="panel social-icon watsapp d-block d-md-none"
                      href={
                        appDetails?.WHATS_APP_URL != ""
                          ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                          : "javascript:void(0)"
                      }
                      target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                    >
                      <img
                        src={WhatsappIcon1}
                        alt="whatsappicon"
                        style={{ width: "38px", margin: "4px" }}
                      />
                    </a>
                    {!isApkEnv ? (
                      <a href="" download="">
                        <img
                          src={APK}
                          alt="Calling icon"
                          style={{ width: "30px", margin: "8px" }}
                        />
                      </a>
                    ) : null}
                    <Button
                      variant="primary"
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                      }}
                      className="button-primary btn_signin"
                      style={{ marginLeft: "4px" }}
                    >
                      SignIn
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
                      }}
                      className="button-primary btn_signup ms-2"
                    >
                      SignUp
                    </Button>
                  </div>
                </div>
                <div className="middle-part d-block d-lg-none">
                  <Navbar>
                    <Container>
                      <Navbar.Toggle aria-controls="basic-navbar-nav" />
                      <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                          {/* <Nav.Link href="/sign-in">
                            <img src={Casino1} alt="bottom head link icon" />
                            <span>Ezugi</span>
                          </Nav.Link>
                          <Nav.Link href="/sign-in">
                            <img src={Evolution} alt="bottom head link icon" />
                            <span>Evolution</span>
                          </Nav.Link> */}
                          <Nav.Link href="/exchange/Cricket">
                            <img
                              src={Exchange}
                              alt="Exchange Icon"
                              width={20}
                            />
                            Exchange
                          </Nav.Link>
                          {/* <Nav.Link href="/betby">
                            <img src={SportsbookIcon} alt="Sportsbook" />{" "}
                            Sportsbook
                          </Nav.Link> */}
                          <Nav.Link href="/sportsbook">
                            <img src={SportsbookIcon} alt="Sportsbook" />
                            <span>Atlas</span>
                          </Nav.Link>
                          <Nav.Link href="/sign-in">
                            <img src={Slots1} alt="bottom head link icon" />
                            <span>Slots</span>
                          </Nav.Link>
                          {/* <Nav.Link href="/casino/supernowa">
                            <img src={supern} alt="bottom head link icon" />
                            <span>Supernowa</span>
                          </Nav.Link>
                          <Nav.Link href="/casino/xpg">
                            <img src={xpg} alt="bottom head link icon" />
                            <span>Xpg</span>
                          </Nav.Link> */}
                          <Nav.Link href="/kingmaker">
                            <img src={kingmaker} alt="bottom head link icon" />
                            <span>Kingmaker</span>
                          </Nav.Link>
                          {/* <Nav.Link href="/casino/qtech">
                            <img src={Qtech} alt="bottom head link icon" />
                            <span>Qtech</span>
                          </Nav.Link> */}
                          <Nav.Link href="/gap">
                            <img src={AltGame} alt="bottom head link icon" />
                            <span>Alt Game</span>
                          </Nav.Link>
                          <Nav.Link href="/turbo-games" className="d-md-none">
                            <img src={AltGame} alt="bottom head link icon" />
                            <span>Turbo Games</span>
                          </Nav.Link>
                          <Nav.Link href="/aura-games">
                            <img src={AltGame} alt="bottom head link icon" />
                            <span>Aura Games</span>
                          </Nav.Link>
                          <Nav.Link href="/sign-in">
                            <img src={kingmaker} alt="bottom head link icon" />
                            <span>Vimplay Games</span>
                          </Nav.Link>
                        </Nav>
                      </Navbar.Collapse>
                    </Container>
                  </Navbar>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="bottom_head d-none">
          <Container fluid>
            <Row>
              <Col xs={12} className="px-0">
                <ul>
                  {/* <li>
                  <a href="/sign-in">
                    <img src={BotHeadIcon1} alt="bottom head link icon" />
                    <span>All Live Games</span>
                  </a>
                </li> */}
                  {/* <li>
                  <a href="/sign-in">
                    <img src={BotHeadIcon2} alt="bottom head link icon" />
                    <span>Exchange</span>
                  </a>
                </li> */}
                  <li>
                    <a href="/sign-in">
                      <img src={Casino1} alt="bottom head link icon" />
                      <span>Ezugi Games</span>
                    </a>
                  </li>

                  {/* <li>
                  <a href="/sign-in">
                    <img src={BotHeadIcon5} alt="bottom head link icon" />
                    <span>From Casino</span>
                  </a>
                </li> */}
                  <li>
                    <a href="/sign-in">
                      <img src={Slots1} alt="bottom head link icon" />
                      <span>Slots</span>
                    </a>
                  </li>
                  <li>
                    <a href="/sign-in">
                      <img src={Evolution} alt="bottom head link icon" />
                      <span>Evolution</span>
                    </a>
                  </li>
                  {/* <li>
                  <a href="/sign-in">
                    <img src={BotHeadIcon7} alt="bottom head link icon" />
                    <span>New Arrivals</span>
                  </a>
                </li> */}
                </ul>
              </Col>
            </Row>
          </Container>
        </div>

        {/* <Offcanvas
        className={"steps-canvas"}
        show={show}
        onHide={handleClose}
        placement={"end"}
      >
        <Offcanvas.Header closeButton="closeButton" closeVariant="white">
          <Offcanvas.Title>
            <span className="top-heading">Sign in now!</span>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form-steps">
            <h2 className="h2">Hello Again!</h2>
            <p>
              Welcome back, you've
              <br />
              been missed!
            </p>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Control type="text" placeholder="Enter Username*" />
              </Form.Group>
              <Form.Group
                className="mb-3 position-relative"
                controlId="formBasicPassword"
              >
                <Form.Control type="password" placeholder="Password*" />
                <span className="icon">
                  <EyeIcon />
                </span>
              </Form.Group>
              <div className="d-flex justify-content-end mb-3">
                <a className="form-link" href="#">
                  Password Recovery
                </a>
              </div>
              <Button variant="primary" type="submit">
                Sign in
              </Button>
            </Form>
            <div className="sign-up mt-4">
              Not a member?
              <br />
              <a href="register">Sign Up Now</a>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas> */}
        {showAuthModals && (
          <ModalWrapper
            defaultShow={defaultModal}
            handleClose={setShowAuthModals}
          />
        )}
      </header>
    </>
  );
};

export default Header;
